import TabletDropdown from "./TabletDropdown";

export default TabletDropdown;
